/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import Box from '../Box/Box';
import { SxProp } from '../style/sxProp';

const LayoutControls: React.FC<
  React.PropsWithChildren<{
    sx?: SxProp;
  }>
> = ({ children, sx }) => (
  <Box
    className="LayoutControls"
    sx={{
      width: '100%',
      boxSizing: 'border-box',
      padding: '3 4 5',
      /*
       * & > *:not(:last-child) is the better selector but seems
       * like its not supported on IE11.
       */
      '& > *': {
        marginBottom: '2',
      },
      '& > *:last-child': {
        marginBottom: '0',
      },
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
        {
          width: '432px',
        },
      ...(sx as any),
    }}
  >
    {children}
  </Box>
);

export default LayoutControls;
